/**
 * Assigned `RegistrationIntakeStatus.statusID` values.
 *
 * Fixed by contract, exactly like `Counselling/requestStatusIds.ts`:
 * `RegistrationIntakeStatus.d.ts` states "Uses fixed/assigned IDs (0=Pending, 1=Approved, -1=Rejected,
 * -2=Cancelled)", and there is no `/LookUp` page that can renumber them.
 */
export const INTAKE_STATUS = {
  Pending: 0,
  Approved: 1,
  Rejected: -1,
  Cancelled: -2,
} as const;

/**
 * Statuses that `changeStatus` refuses with a **400**.
 *
 * ⚠️ Reaching either has side effects a bare status write would skip: approving creates the
 * registration and its participant members, rejecting closes the intake and notifies the applicant.
 * Writing the status directly would leave an intake marked approved with no registration behind it.
 * Route these through `approve()` / `reject()` instead.
 */
export const WORKFLOW_OWNED_STATUS: number[] = [INTAKE_STATUS.Approved, INTAKE_STATUS.Rejected];

export const isWorkflowOwned = (statusID: number) => WORKFLOW_OWNED_STATUS.includes(statusID);
